import pluralize from '@sravni/utils/lib/pluralize';
import { Currency } from '../../constants/currency.js';
import { getAmountString } from '../../helpers/humanization.js';

const termEducation = ({ timeAllDay, timeAllMonth, timeAllHour }) => {
    if (timeAllHour) {
        return `${timeAllHour} ${pluralize(timeAllHour, 'час', 'часа', 'часов')}`;
    }
    if (timeAllDay) {
        return `${timeAllDay} ${pluralize(timeAllDay, 'день', 'дня', 'дней')}`;
    }
    if (timeAllMonth) {
        return `${timeAllMonth} ${pluralize(timeAllMonth, 'месяц', 'месяца', 'месяцев')}`;
    }
    return 'Бессрочно';
};
const getEducationalTypeTerms = item => {
    const conditions = [];
    const { priceAll, priceInstallment, timeAllDay, timeAllMonth, timeAllHour } = item;
    const timeValue = termEducation({ timeAllDay, timeAllMonth, timeAllHour });
    const priceValue = getAmountString(priceAll, Currency.RUB);
    conditions.push({
        value: priceValue,
        description: 'Цена',
        key: 'price',
    }, {
        value: timeValue,
        description: 'Срок обучения',
        key: 'time',
    }, {
        value: priceInstallment ? `${getAmountString(priceInstallment, Currency.RUB)}/мес.` : 'Нет',
        description: 'Рассрочка',
        key: 'priceInstant',
    });
    return conditions;
};

export { getEducationalTypeTerms };
//# sourceMappingURL=educationalType.js.map
